<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <div class="columns" v-show="showList">
        <div class="column">
          <section class="hero is-info" v-show="showList">
            <div class="hero-body">
              <div class="container">
                <h1 class="title is-4">
                  รายการรถ สาขา {{ branchSelected }}
                </h1>
              </div>
            </div>
            <article class="message" v-show="!dataAlready">
              <div class="message-body">กำลังดึงข้อมูล...</div>
            </article>
            <table class="table" style="width:100%" v-show="dataAlready">
            <thead>
              <tr>
                <th width="50"><abbr title="action"></abbr></th>
                <th><abbr title="runNo">ลำดับที่</abbr></th>
                <th><abbr title="licenseNo">ทะเบียน</abbr></th>
                <th><abbr title="status">สถานะ</abbr></th>
                <th><abbr title="ID">ID</abbr></th>
                <th><abbr title="userId">userId</abbr></th>
                <th><abbr title="customerName">customerName</abbr></th>
                <th width="50"><abbr title="action"></abbr></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="car in carList" v-bind:key="car.id">
                <td>
                  <div class="buttons are-small">
                    <button  class="button is-info" v-on:click="cloneJob($event, car.id, car.runNo)" >Clone</button>
                  </div>
                </td>
                <td>
                  <span class="error" v-if="(car.userId === -1)">*</span>
                  {{car.runNo}}
                </td>
                <td>{{car.licenseNo}}</td>
                <td>{{car.status}}</td>
                <td>{{car.id}}</td>
                <td>{{car.userId}}</td>
                <td>{{car.customerName}}</td>
                <td>
                  <div class="buttons are-small">
                    <button  class="button is-danger" v-on:click="closeJob($event, car.id, car.runNo)" >Close</button>
                    <button  class="button is-danger" v-on:click="deleteJob($event, car.id, car.runNo)" >Delete</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </section>
        </div>
    </div>
  </div>
</template>
<style>
.banner {
  text-align: center;
  background-color: #000;
}
.error {
  color: red;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Progress',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    size: 200,
    showComplete: false,
    dataAlready: false,
    confirmSuccess: false,
    showList: true,
    selectTechnician: false,
    selectLeader: false,
    inputCost: false,
    branch: [],
    step: [
      {
        current: 'start',
        title: 'รับรถเข้าบริการ',
        nextstep: [{
          title: 'ส่งคิวซ่อม',
          action: 'queue_repair'
        }]
      },
      {
        current: 'queue_repair',
        title: 'รอคิวซ่อม',
        nextstep: [{
          title: 'ส่งซ่อม',
          action: 'repair'
        }]
      },
      {
        current: 'repair',
        title: 'กำลังซ่อม',
        nextstep: [{
          title: 'ส่งตรวจสอบ',
          action: 'final_inspec'
        }]
      },
      {
        current: 'final_inspec',
        title: 'รอตรวจสอบขั้นสุดท้าย',
        nextstep: [{
          title: 'ผ่าน',
          action: 'cleaning'
        },
        {
          title: 'แจ้งเพิ่มเติม',
          action: 'repair'
        }]
      },
      {
        current: 'cost_summary',
        title: 'รอสรุปค่าใช้จ่าย',
        nextstep: [{
          title: 'สรุปเสร็จแล้ว',
          action: 'cleaning'
        }]
      }, {
        current: 'cleaning',
        title: 'กำลังทำความสะอาด',
        nextstep: [{
          title: 'ส่งมอบรถ',
          action: 'complete'
        }]
      }
    ],
    stepCurrent: {},
    branchSelected: '',
    branchCode: '',
    carInfo: {
      runNo: '',
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: ''
    },
    carId: '',
    carList: [],
    current_step: '',
    leaderId: '',
    btn_confirm_title: 'ยืนยัน',
    action_select: '',
    error_msg: '',
    t: null
  }),
  mounted () {
    let _this = this
    _this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    _this.branchCode = params.get('branchCode')
    const branchSelected = _this.branch.find((item) => item.id === _this.branchCode)
    _this.branchSelected = branchSelected ? branchSelected.name : ''
    _this.stepCurrent = _this.step.find((item) => item.current === _this.current_step)
    _this.getCarList()
  },
  methods: {
    getCarList () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getJobAll?branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data
          _this.showList = true
          _this.btn_confirm_title = 'ยืนยัน'
          _this.error_msg = ''
        })
    },
    closeJob (event, carId, runNo) {
      if (!confirm('คุณต้องการ manual close งานเลขที่ ' + runNo)) {
        return false
      }
      let _this = this
      let params = {
        carId: carId
      }
      this.$axios
        .post(`${this.$apiUrl}closeJob`, params)
        .then(response => {
          _this.getCarList()
        })
    },
    deleteJob (event, carId, runNo) {
      if (!confirm('ยืนยันการลบงานหมายเลข ' + runNo)) {
        return false
      }
      let _this = this
      let params = {
        carId: carId
      }
      this.$axios
        .post(`${this.$apiUrl}deleteJob`, params)
        .then(response => {
          _this.getCarList()
        })
    },
    cloneJob (event, carId, runNo) {
      if (!confirm('คุณต้องการ clone งานหมายเลข ' + runNo)) {
        return false
      }
      let _this = this
      let params = {
        carId: carId
      }
      this.$axios
        .post(`${this.$apiUrl}cloneJob`, params)
        .then(response => {
          _this.getCarList()
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Manage.vue